import type { LibraryItem } from '@pega/cosmos-react-build';

export const lifeCycleEmptyData = {
  id: '100',
  categories: [],
  stages: [
    {
      id: '1',
      label: 'Create',
      type: 'start',
      error: '',
      categories: [
        {
          id: '2',
          categoryId: '',
          tasks: [
            [
              {
                id: '3',
                label: 'Process',
                visual: {
                  imgSrc: ''
                },
                error: '',
                steps: [
                  {
                    id: '4',
                    label: 'Form',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'pega data',
                      category: 'task',
                      inverted: false
                    },
                    status: {
                      type: '',
                      label: ''
                    },
                    error: ''
                  }
                ]
              }
            ]
          ]
        }
      ]
    }
  ],
  alternateStages: []
};

export const lifeCycleEmptyPlanViewData = {
  id: '100',
  categories: [
    {
      label: 'Personas and Channels',
      id: 'Category1'
    },
    {
      label: 'Data and system',
      id: 'Category2'
    }
  ],
  stages: [
    {
      id: '1',
      label: 'create',
      type: 'start',
      error: '',
      categories: [
        {
          id: '2',
          categoryId: 'Category2',
          tasks: []
        },
        {
          id: '9',
          categoryId: 'Category1',
          tasks: []
        }
      ]
    }
  ],
  alternateStages: []
};

export const lifeCyclePlanViewData = {
  id: '100',
  categories: [
    {
      label: 'Personas and Channels',
      id: 'Category1'
    },
    {
      label: 'Data and system',
      id: 'Category2'
    }
  ],
  stages: [
    {
      id: '1',
      label: 'Apply for job',
      type: 'start',
      error: '',
      categories: [
        {
          id: '2',
          categoryId: 'Category2',
          tasks: [
            {
              id: '3',
              label: 'Pega Attachments',
              visual: {
                imgSrc: ''
              },
              error: '',
              steps: [
                {
                  id: '4',
                  label: 'Pega',
                  visual: {
                    imgSrc: '',
                    name: 'pegasus',
                    label: 'pega data',
                    category: 'rule',
                    inverted: false
                  },
                  status: {
                    label: 'MLP 1',
                    type: 'success'
                  },
                  error: ''
                },
                {
                  id: '5',
                  label: 'Customer Data',
                  visual: {
                    imgSrc: '',
                    name: 'document-pdf',
                    label: 'data',
                    category: 'automation',
                    inverted: false
                  },
                  status: {
                    label: 'MLP 2',
                    type: 'success'
                  },
                  error: ''
                }
              ]
            },
            {
              id: '6',
              label: 'User Attachments',
              visual: {
                imgSrc: ''
              },
              error: '',
              steps: [
                {
                  id: '7',
                  label: 'User Data',
                  visual: {
                    imgSrc: '',
                    name: 'user-document',
                    label: 'data',
                    category: 'task',
                    inverted: false
                  },
                  status: {
                    label: 'MLP 1',
                    type: 'warn'
                  },
                  error: ''
                },
                {
                  id: '8',
                  label: 'Uploads',
                  visual: {
                    imgSrc: '',
                    name: 'user-document',
                    label: 'data upload',
                    category: 'task',
                    inverted: false
                  },
                  status: {
                    label: 'MLP 2',
                    type: 'pending'
                  },
                  error: ''
                }
              ]
            }
          ]
        },
        {
          id: '9',
          categoryId: 'Category1',
          tasks: [
            {
              id: '10',
              label: 'Manager',
              visual: {
                imgSrc:
                  'https://pbs.twimg.com/profile_images/824369446798106628/_biA5GRt_400x400.jpg'
              },
              error: '',
              steps: [
                {
                  id: '11',
                  label: 'Manager portal',
                  visual: {
                    imgSrc: '',
                    name: 'multi-device',
                    label: 'portal',
                    category: 'rule',
                    inverted: true
                  },
                  status: {
                    label: 'MLP 1',
                    type: 'success'
                  },
                  error: ''
                },
                {
                  id: '12',
                  label: 'Send email',
                  visual: {
                    imgSrc: '',
                    name: 'gear-play',
                    label: 'email',
                    category: 'automation',
                    inverted: false
                  },
                  status: {
                    label: 'MLP 2',
                    type: 'info'
                  },
                  error: ''
                }
              ]
            },
            {
              id: '13',
              label: 'User',
              visual: {
                imgSrc: ''
              },
              error: '',
              steps: [
                {
                  id: '14',
                  label: 'User portal',
                  visual: {
                    imgSrc: '',
                    name: 'user',
                    label: 'portal',
                    category: 'task',
                    inverted: false
                  },
                  status: {
                    label: 'MLP 1',
                    type: 'success'
                  },
                  error: ''
                },
                {
                  id: '15',
                  label: 'Mobile Application',
                  visual: {
                    imgSrc: '',
                    name: 'mobile-phone',
                    label: 'phone',
                    category: 'task',
                    inverted: false
                  },
                  status: {
                    label: 'MLP 3',
                    type: 'urgent'
                  },
                  error: ''
                }
              ]
            },
            {
              id: '16',
              label: 'Back Office Users',
              visual: {
                imgSrc:
                  'https://pbs.twimg.com/profile_images/824369446798106628/_biA5GRt_400x400.jpg'
              },
              error: '',
              steps: [
                {
                  id: '17',
                  label: 'Web services',
                  visual: {
                    imgSrc: '',
                    name: 'gear-play',
                    label: 'web server',
                    category: 'automation',
                    inverted: false
                  },
                  status: {
                    label: '',
                    type: ''
                  },
                  error: ''
                }
              ]
            }
          ]
        }
      ]
    },
    {
      id: '18',
      label: 'Review',
      type: 'default',
      error: '',
      transitionType: 'wait',
      categories: [
        {
          id: '19',
          categoryId: 'Category1',
          tasks: [
            {
              id: '20',
              label: 'Back Office Users',
              visual: {
                imgSrc: ''
              },
              error: '',
              steps: [
                {
                  id: '21',
                  label: 'Web services',
                  visual: {
                    imgSrc: '',
                    name: 'gear-play',
                    label: 'web server',
                    category: 'automation',
                    inverted: false
                  },
                  status: {
                    label: '',
                    type: ''
                  },
                  error: ''
                },
                {
                  id: '22',
                  label: 'Mobile services',
                  visual: {
                    imgSrc: '',
                    name: 'mobile-phone',
                    label: 'phone',
                    category: 'task',
                    inverted: false
                  },
                  status: {
                    label: '',
                    type: ''
                  },
                  error: ''
                }
              ]
            }
          ]
        },
        {
          id: '23',
          categoryId: 'Category2',
          tasks: [
            {
              id: '24',
              label: 'Case Data',
              visual: {
                imgSrc: ''
              },
              error: '',
              steps: [
                {
                  id: '25',
                  label: 'Documents submission',
                  visual: {
                    imgSrc: '',
                    name: 'user-document',
                    label: 'documents',
                    category: 'task',
                    inverted: false
                  },
                  status: {
                    label: 'MLP 1',
                    type: 'success'
                  },
                  error: ''
                },
                {
                  id: '26',
                  label: 'Verify Documents',
                  visual: {
                    imgSrc: '',
                    name: 'clipboard-check',
                    label: 'verify',
                    category: 'task',
                    inverted: false
                  },
                  status: {
                    label: 'MLP 4',
                    type: 'pending'
                  },
                  error: ''
                }
              ]
            }
          ]
        }
      ]
    },
    {
      id: '27',
      label: 'Interview',
      error: '',
      type: 'default',
      categories: [
        {
          id: '28',
          categoryId: 'Category1',
          tasks: [
            {
              id: '29',
              label: 'HR Hub',
              visual: {
                imgSrc: ''
              },
              error: '',
              steps: [
                {
                  id: '30',
                  label: 'HR portal',
                  visual: {
                    imgSrc: '',
                    name: 'desktop',
                    label: 'HR',
                    category: 'case',
                    inverted: true
                  },
                  status: {
                    label: 'MLP 1',
                    type: 'pending'
                  },
                  error: ''
                },
                {
                  id: '31',
                  label: 'Send feedback',
                  visual: {
                    imgSrc: '',
                    name: 'docusign',
                    label: 'Channel',
                    category: 'rule',
                    inverted: true
                  },
                  status: {
                    label: '',
                    type: ''
                  },
                  error: ''
                }
              ]
            }
          ]
        },
        {
          id: '32',
          categoryId: 'Category2',
          tasks: [
            {
              id: '33',
              label: 'HR',
              visual: {
                imgSrc: ''
              },
              error: '',
              steps: [
                {
                  id: '34',
                  label: 'Candidate Info',
                  visual: {
                    imgSrc: '',
                    name: 'information',
                    label: 'Info',
                    category: 'task',
                    inverted: false
                  },
                  status: {
                    label: 'MLP 1',
                    type: 'info'
                  },
                  error: ''
                }
              ]
            }
          ]
        }
      ]
    },
    {
      id: '35',
      label: 'Release offer',
      error: '',
      type: 'default',
      transitionType: 'resolution',
      categories: [
        {
          id: 'uniqueId',
          categoryId: 'Category1',
          tasks: []
        },
        {
          id: '36',
          categoryId: 'Category2',
          tasks: []
        }
      ]
    }
  ],
  alternateStages: [
    {
      id: '37',
      label: 'Rejected Offer',
      error: '',
      type: 'alternate',
      categories: [
        {
          id: '38',
          categoryId: 'Category1',
          tasks: [
            {
              id: '39',
              label: 'HR',
              visual: {
                imgSrc: ''
              },
              error: '',
              steps: [
                {
                  id: '40',
                  label: 'HR portal',
                  visual: {
                    imgSrc: '',
                    name: 'desktop',
                    label: 'HR',
                    category: 'case',
                    inverted: true
                  },
                  status: {
                    label: 'MLP 1',
                    type: 'pending'
                  },
                  error: ''
                },
                {
                  id: '41',
                  label: 'get feedback',
                  visual: {
                    imgSrc: '',
                    name: 'docusign',
                    label: 'Channel',
                    category: 'rule',
                    inverted: true
                  },
                  status: {
                    label: '',
                    type: ''
                  },
                  error: ''
                }
              ]
            }
          ]
        },
        {
          id: '42',
          categoryId: 'Category2',
          tasks: [
            {
              id: '43',
              label: 'Interview Data',
              visual: {
                imgSrc: ''
              },
              error: '',
              steps: [
                {
                  id: '44',
                  label: 'Interviewers',
                  visual: {
                    imgSrc: '',
                    name: 'information',
                    label: 'Info',
                    category: 'task',
                    inverted: false
                  },
                  status: {
                    label: 'MLP 1',
                    type: 'info'
                  },
                  error: ''
                }
              ]
            }
          ]
        }
      ]
    },
    {
      id: '45',
      label: 'Release offer',
      error: '',
      type: 'alternate',
      transitionType: 'resolution',
      categories: [
        {
          id: '46',
          categoryId: 'Category1',
          tasks: []
        },
        {
          id: '47',
          categoryId: 'Category2',
          tasks: []
        }
      ]
    }
  ]
};

export const lifeCycleWorkFlowData = {
  id: 'unique01',
  categories: [],
  stages: [
    {
      id: '1',
      label: 'Apply for job',
      type: 'start',
      error: '',
      categories: [
        {
          id: '2',
          categoryId: '',
          tasks: [
            [
              {
                id: '3',
                label: 'Collect information',
                visual: {
                  imgSrc: ''
                },
                error: '',
                steps: [
                  {
                    id: '4',
                    label: 'Personal details',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'details',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '5',
                    label: 'Work history',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'history',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '6',
                    label: 'Technical skills',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'technical',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '7',
                    label: 'Address',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'location',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '8',
                    label: 'Availability ',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'date',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  }
                ]
              },
              {
                id: '9',
                label: 'Submit application',
                visual: {
                  imgSrc: ''
                },
                error: '',
                steps: [
                  {
                    id: '10',
                    label: 'Register',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'register',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '11',
                    label: 'Upload resume',
                    visual: {
                      imgSrc: '',
                      name: 'gear-play',
                      label: 'upload',
                      category: 'automation',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '12',
                    label: 'Apply',
                    visual: {
                      imgSrc: '',
                      name: 'clipboard-check',
                      label: 'apply',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  }
                ]
              }
            ]
          ]
        }
      ]
    },
    {
      id: '13',
      label: 'Review',
      type: 'default',
      error: '',
      transitionType: 'wait',
      categories: [
        {
          id: '14',
          categoryId: '',
          tasks: [
            [
              {
                id: '15',
                label: 'Review application',
                visual: {
                  imgSrc: ''
                },
                error: '',
                steps: [
                  {
                    id: '16',
                    label: 'Review candidates for position',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'review',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '17',
                    label: 'Contact applicants',
                    visual: {
                      imgSrc: '',
                      name: 'multi-device',
                      label: 'Channel',
                      category: 'rule',
                      inverted: true
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '18',
                    label: 'Screening',
                    visual: {
                      imgSrc: '',
                      name: 'gear-play',
                      label: 'screening',
                      category: 'automation',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '19',
                    label: 'Approve candidate',
                    visual: {
                      imgSrc: '',
                      name: 'check-badge',
                      label: 'approve',
                      category: 'logic',
                      inverted: true
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  }
                ]
              }
            ],
            [
              {
                id: '20',
                label: 'Schedule Interview 1',
                visual: {
                  imgSrc: ''
                },
                error: '',
                steps: [
                  {
                    id: '21',
                    label: 'Get Panel',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'get panel',
                      category: 'task',
                      inverted: false
                    },
                    status: {
                      label: 'MLP 1',
                      type: 'info'
                    },
                    error: ''
                  },
                  {
                    id: '22',
                    label: 'Send Email',
                    visual: {
                      imgSrc: '',
                      name: 'gear-play',
                      label: 'Channel',
                      category: 'automation',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  }
                ]
              },
              {
                id: '99',
                label: 'Schedule Interview 2',
                visual: {
                  imgSrc: ''
                },
                error: '',
                steps: [
                  {
                    id: '101',
                    label: 'Get Panel',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'get panel',
                      category: 'task',
                      inverted: false
                    },
                    status: {
                      label: 'MLP 1',
                      type: 'info'
                    },
                    error: ''
                  },
                  {
                    id: '102',
                    label: 'Send Email',
                    visual: {
                      imgSrc: '',
                      name: 'gear-play',
                      label: 'Channel',
                      category: 'automation',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  }
                ]
              }
            ],
            [
              {
                id: '23',
                label: 'Schedule Manager Round',
                visual: {
                  imgSrc: ''
                },
                error: '',
                steps: [
                  {
                    id: '24',
                    label: 'Get Panel',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'get panel',
                      category: 'task',
                      inverted: false
                    },
                    status: {
                      label: 'MLP 1',
                      type: 'info'
                    },
                    error: ''
                  },
                  {
                    id: '25',
                    label: 'Send Email',
                    visual: {
                      imgSrc: '',
                      name: 'gear-play',
                      label: 'Channel',
                      category: 'automation',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  }
                ]
              }
            ]
          ]
        }
      ]
    },
    {
      id: '26',
      label: 'Interview',
      type: 'default',
      error: '',
      categories: [
        {
          id: '27',
          categoryId: '',
          tasks: [
            [
              {
                id: '28',
                label: 'Conduct Interview',
                visual: {
                  imgSrc: ''
                },
                error: '',
                steps: [
                  {
                    id: '29',
                    label: 'HackerEarth Test',
                    visual: {
                      imgSrc: '',
                      name: 'code',
                      label: 'coding test',
                      category: 'rule',
                      inverted: true
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '30',
                    label: 'Technical 1',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'technical',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '31',
                    label: 'Technical 2',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'technical',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '32',
                    label: 'Technical 3',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'technical',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '33',
                    label: 'Send Email',
                    visual: {
                      imgSrc: '',
                      name: 'gear-play',
                      label: 'email',
                      category: 'automation',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  }
                ]
              }
            ]
          ]
        }
      ]
    },
    {
      id: '34',
      label: 'Release Offer',
      type: 'default',
      error: '',
      transitionType: 'resolution',
      categories: [
        {
          id: '35',
          categoryId: '',
          tasks: []
        }
      ]
    }
  ],
  alternateStages: [
    {
      id: '36',
      label: 'Rejected Offer',
      type: 'alternate',
      error: '',
      categories: [
        {
          id: '37',
          categoryId: '',
          tasks: [
            [
              {
                id: '38',
                label: 'Contact candidate',
                visual: {
                  imgSrc: ''
                },
                error: '',
                steps: [
                  {
                    id: '39',
                    label: 'Send Email',
                    visual: {
                      imgSrc: '',
                      name: 'gear-play',
                      label: 'details',
                      category: 'automation',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '40',
                    label: 'Make a call',
                    visual: {
                      imgSrc: '',
                      name: 'gear-play',
                      label: 'phone',
                      category: 'automation',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  }
                ]
              }
            ]
          ]
        }
      ]
    },
    {
      id: '41',
      label: 'Candidate unavailable',
      type: 'alternate',
      transitionType: 'resolution',
      error: '',
      categories: [
        {
          id: '42',
          categoryId: '',
          tasks: []
        }
      ]
    }
  ]
};

export const lifeCycleAdhocCaseFlowData = {
  id: 'unique01',
  categories: [],
  stages: [
    {
      id: '1',
      label: 'Information Gathering',
      type: 'start',
      error: '',
      categories: [
        {
          id: '2',
          categoryId: '',
          tasks: [
            [
              {
                id: '3',
                label: 'Collect information',
                visual: {
                  imgSrc: ''
                },
                error: '',
                steps: [
                  {
                    id: '4',
                    label: 'Personal details',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'details',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '5',
                    label: 'Work history',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'history',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '6',
                    label: 'Technical skills',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'technical',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '7',
                    label: 'Address',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'location',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '8',
                    label: 'Availability ',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'date',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  }
                ]
              }
            ]
          ]
        }
      ]
    },
    {
      id: '13',
      label: 'Review',
      type: 'default',
      error: '',
      // transitionType: 'wait',
      categories: [
        {
          id: '14',
          categoryId: '',
          tasks: [
            [
              {
                id: '15',
                label: 'Review application',
                visual: {
                  imgSrc: ''
                },
                error: '',
                steps: [
                  {
                    id: '16',
                    label: 'Review candidates',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'review',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '17',
                    label: 'Contact applicants',
                    visual: {
                      imgSrc: '',
                      name: 'multi-device',
                      label: 'Channel',
                      category: 'rule',
                      inverted: true
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '18',
                    label: 'Screening',
                    visual: {
                      imgSrc: '',
                      name: 'gear-play',
                      label: 'screening',
                      category: 'automation',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '19',
                    label: 'Approve candidate',
                    visual: {
                      imgSrc: '',
                      name: 'check',
                      label: 'approve',
                      category: 'logic',
                      inverted: true
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  }
                ]
              }
            ]
          ]
        }
      ]
    },
    {
      id: '42',
      label: 'Interview',
      type: 'default',
      error: '',
      transitionType: 'resolution',
      categories: [
        {
          id: '43',
          categoryId: '',
          tasks: [
            [
              {
                id: '44',
                label: 'Conduct Interview',
                visual: {
                  imgSrc: ''
                },
                error: '',
                steps: [
                  {
                    id: '45',
                    label: 'HackerEarth Test',
                    visual: {
                      imgSrc: '',
                      name: 'code',
                      label: 'coding test',
                      category: 'rule',
                      inverted: true
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '46',
                    label: 'Technical 1',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'technical',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '47',
                    label: 'Technical 2',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'technical',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '48',
                    label: 'Technical 3',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'technical',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '49',
                    label: 'Send Email',
                    visual: {
                      imgSrc: '',
                      name: 'gear-play',
                      label: 'email',
                      category: 'automation',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  }
                ]
              }
            ]
          ]
        }
      ]
    }
  ],
  alternateStages: []
};

export const workFlowNodeLibrary: LibraryItem[] = [
  {
    id: 'decision',
    primary: 'Decision',
    type: {
      icon: { name: 'diamond', category: 'logic', label: 'Decision step logic' }
    }
  },
  {
    id: 'assignment',
    primary: 'Assignment',
    type: {
      icon: { name: 'user-document', category: 'task', label: 'Assignment case type' }
    }
  },
  {
    id: 'automation',
    primary: 'Automation',
    type: {
      icon: { name: 'gear-play', category: 'automation', label: 'Automation object' }
    },
    items: [
      {
        id: 'pdf',
        primary: 'Generate PDF',
        type: {
          icon: { name: 'gear-play', category: 'automation', label: 'Generate PDF object' }
        }
      },
      {
        id: 'sendemail',
        primary: 'Send email',
        type: {
          icon: { name: 'gear-play', category: 'automation', label: 'Send email object' }
        }
      }
    ]
  }
];

export const planViewNodeLibrary: LibraryItem[] = [
  {
    id: 'Manager portal',
    primary: 'Manager portal',
    type: {
      icon: { name: 'multi-device', label: 'Manager portal', category: 'rule', inverted: true }
    }
  },

  {
    id: 'Mobile Application',
    primary: 'Mobile Application',
    type: {
      icon: { name: 'mobile-phone', category: 'task', label: 'Mobile Application object' }
    }
  },
  {
    id: 'User portal',
    primary: 'Automation',
    type: {
      icon: { name: 'gear-play', category: 'automation', label: 'Automation object' }
    },
    items: [
      {
        id: 'Send email',
        primary: 'Send email',
        type: {
          icon: { name: 'gear-play', category: 'automation', label: 'Send email object' }
        }
      },
      {
        id: 'Web services',
        primary: 'Web services',
        type: {
          icon: { name: 'gear-play', category: 'automation', label: 'Web services object' }
        }
      }
    ]
  }
];

export const adhocCaseFlowNodeLibrary: LibraryItem[] = [
  {
    id: 'decision',
    primary: 'Decision',
    type: {
      icon: { name: 'diamond', category: 'logic', label: 'Decision step logic' }
    }
  },
  {
    id: 'assignment',
    primary: 'Assignment',
    type: {
      icon: { name: 'user-document', category: 'task', label: 'Assignment case type' }
    }
  },
  {
    id: 'automation',
    primary: 'Automation',
    type: {
      icon: { name: 'gear-play', category: 'automation', label: 'Automation object' }
    },
    items: [
      {
        id: 'pdf',
        primary: 'Generate PDF',
        type: {
          icon: { name: 'gear-play', category: 'automation', label: 'Generate PDF object' }
        }
      },
      {
        id: 'sendemail',
        primary: 'Send email',
        type: {
          icon: { name: 'gear-play', category: 'automation', label: 'Send email object' }
        }
      }
    ]
  }
];

export const selectOptions = [
  { id: 0, value: 'Choose' },
  { id: 1, value: 'Me' },
  { id: 2, value: 'Current User' },
  { id: 3, value: 'Work Queue' }
];
